import React, { useState } from 'react';
import { Checkbox } from '@mui/material';
import dayjs from 'dayjs';
import { TaskStatus } from '~/components/tasks/TaskStatus';
import { EditTaskModal } from '~/components/tasks/EditTaskModal';
import { useQueryClient } from "react-query";
export const PatientHubTaskRow = (props) => {
    const { task, taskSelected, selectedTaskIds, doneSelected } = props;
    const [showEditTaskModal, setShowEditTaskModal] = useState(false);
    const queryClient = useQueryClient();
    const cellClass = 'table-cell pt-4 pb-4 align-middle';
    const textStyle = {
        fontFamily: 'Barlow',
        color: '#000000DE',
        fontWeight: '500',
        fontSize: 'small',
    };
    const getTaskDueDateStyle = () => {
        const today = dayjs().startOf('day');
        if (task.status === 'Done') {
            return {
                fontFamily: 'Barlow',
                color: '#000000DE',
                fontWeight: '500',
                fontSize: 'small',
            };
        }
        return dayjs(task.dueDate).startOf('day').isAfter(today) ?
            {
                fontFamily: 'Barlow',
                color: '#000000DE',
                fontWeight: '500',
                fontSize: 'small',
            }
            :
                {
                    fontFamily: 'Barlow',
                    color: '#D32F2F',
                    fontWeight: '500',
                    fontSize: 'small',
                };
    };
    return (React.createElement("div", { key: task.id, className: "table-row" },
        showEditTaskModal &&
            React.createElement(EditTaskModal, { onRequestClose: () => setShowEditTaskModal(false), onTaskAdded: () => {
                    queryClient.invalidateQueries(['tasksCount']);
                    queryClient.invalidateQueries(['tasksForPractice']);
                }, taskToEdit: task }),
        React.createElement("div", { className: cellClass },
            React.createElement("div", { className: "flex items-center" },
                React.createElement(Checkbox, { onClick: () => taskSelected(task.id), style: { marginRight: '10px' }, size: "medium", color: "primary", checked: selectedTaskIds.includes(task.id) }),
                React.createElement("div", { style: { cursor: 'pointer' }, onClick: () => setShowEditTaskModal(true) },
                    React.createElement("p", { style: {
                            ...textStyle,
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            whiteSpace: 'nowrap',
                            maxWidth: '150px'
                        } }, task.taskName)))),
        React.createElement("div", { style: { cursor: 'pointer' }, onClick: () => setShowEditTaskModal(true), className: `${cellClass} text-center` },
            React.createElement("p", { style: getTaskDueDateStyle() }, dayjs(task.dueDate).format('YYYY-MM-DD'))),
        React.createElement("div", { style: { cursor: 'pointer' }, onClick: () => setShowEditTaskModal(true), className: `${cellClass} text-center` },
            React.createElement("p", { style: textStyle }, task.assignedToName)),
        React.createElement("div", { style: { cursor: 'pointer' }, onClick: () => setShowEditTaskModal(true), className: `${cellClass} text-center` },
            React.createElement("p", { style: textStyle }, task.assignedByName)),
        React.createElement("div", { style: { cursor: 'pointer' }, onClick: () => setShowEditTaskModal(true), className: `${cellClass} text-center` },
            React.createElement("p", { style: {
                    ...textStyle,
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap',
                    maxWidth: '150px',
                    marginLeft: 'auto',
                    marginRight: 'auto'
                } }, task.taskNotes)),
        React.createElement(TaskStatus, { taskId: task.id, taskStatus: task.status, onTaskUpdate: props.onTaskUpdate }),
        doneSelected && React.createElement("div", { style: { cursor: 'pointer' }, onClick: () => setShowEditTaskModal(true), className: `${cellClass} text-center` },
            React.createElement("p", { style: textStyle }, task.completedAt ? dayjs(task.completedAt).format('YYYY-MM-DD HH:mm:ss') : ''))));
};
